import * as Styled from 'components/Toolkit/SubTitleImage/SubTitleImage.styled';
import type { SubTitleImageProps } from 'components/Toolkit/SubTitleImage/SubTitleImage.typed';

const SubTitleImage = (props: SubTitleImageProps) => {
  const { subTitle, imageUrl, imageAltText, className } = props;
  return (
    <Styled.Container className={className}>
      <Styled.Subtitle>{subTitle}</Styled.Subtitle>
      <Styled.Image src={imageUrl} alt={imageAltText} />
    </Styled.Container>
  );
};

export { SubTitleImage };
